export const selectModalAddTransactionOpen = state =>
  state.global.isModalAddTransactionOpen;

export const selectLogoutModalOpen = state => state.global.isModalLogoutOpen;
